import { render } from "./AssistantPanel.vue?vue&type=template&id=2fca8437&scoped=true"
import script from "./AssistantPanel.vue?vue&type=script&lang=js"
export * from "./AssistantPanel.vue?vue&type=script&lang=js"

import "./AssistantPanel.vue?vue&type=style&index=0&id=2fca8437&scoped=true&lang=css"
import "./AssistantPanel.vue?vue&type=style&index=1&id=2fca8437&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fca8437"]])

export default __exports__